import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {getTest, postTestResults} from "../actions";
import {connect} from "react-redux";
import '../assets/css/test.css'
import {SEND} from "../utilities/const";
import $ from "jquery";


class Test extends Component {

    constructor(props) {
        super(props);
        this.state = {
            testContent: null,
        }
    }

    componentWillMount() {
        console.log("Sending request from component will mount");
        this.props.getTest(this.props.match.params.test_id, true);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.test && this.props.test.length > 0 && this.state.testContent === prevState.testContent) {
            this.flattenTest(this.props.test);
        }
    }

    componentDidMount() {
        console.log("Sending request from test");
    }

    flattenTest = test => {
        let testContent = test.map((question, index) => this.makeQuestion(question, index));
        this.setState({testContent: testContent});
    };

    makeQuestion = (question, index) => {
        return (<div className="question" key={question.question_id} defaultValue={question.question_id}>
            <input type="text" name="question" defaultValue={question.question_id} hidden/>
            <p style={{marginBottom: 0}}>{(index + 1) + ") "} {this.convertToDom(question.question_html, true)} </p>
            {this.makeAnswer(question)}
        </div>);
    };

    makeAnswer = question => {
        if (parseInt(question.question_type) === 1) {
            return question.variants.map((answer) => {
                let ansClass = 'variant';
                if (this.props.test_checked.length !== 0) {
                    let isChecked = this.props.test_checked[question.question_id][answer.id];
                    if (isChecked)
                        ansClass = 'correct-ans';
                    else if (isChecked == false)
                        ansClass = 'wrong-ans';
                }
                return (
                    <label key={answer.id} className={ansClass}>
                        <input type="radio"
                               name={"" + question.question_id}
                               value={answer.id}/>{this.convertToDom(answer.html)}<br/></label>);
            })
        }
    };

    render() {
        if (this.state.testContent) {
            return (
                <form className="test_content" onSubmit={this.handleSubmit}>{this.state.testContent}
                    {this.state.testContent.length !== 0 &&
                    this.props.test_checked &&
                    this.props.test_checked.length === 0 &&
                    <input type="submit" value={SEND} className={`sendButton btn`}/>
                    }
                    {this.props.test_checked.length !== 0 && this.props.test_checked["result"]}
                </form>)
        }
        return (<div><p>This is not the TEST You're looking for</p></div>)

    }

    handleSubmit = (e) => {
        e.preventDefault();
        let questions = $("input[type='text'][name='question']");
        let data = {};

        for (let i = 0; i < questions.length; i++) {
            let selected_answer = $("input[type='radio'][name='" + questions[i].defaultValue + "']:checked");
            let result_value;
            let mc_ans = [];
            if (selected_answer.length === 0) {
                selected_answer = $("input[type='checkbox'][name='" + questions[i].defaultValue + "']:checked");
                for (let i = 0; i < selected_answer.length; i++) {
                    mc_ans.push(selected_answer[i].value);
                }
                result_value = mc_ans;
            } else {
                result_value = selected_answer[0].value
            }
            data[questions[i].defaultValue] = result_value;
        }
        this.props.postTestResults(data, true);
    };

    convertToDom = (html, is_bold=false) => {
        return <span style={{color: "black", fontSize: "1rem", fontWeight: is_bold ? "bold" : "normal"}} dangerouslySetInnerHTML={{__html: html}}/>
    }
}


const mapStateToProps = state => ({
    test: state.test_content,
    test_checked: state.test_checked,
});

function dispatchToProps(dispatch) {
    return bindActionCreators({
        getTest: getTest,
        postTestResults: postTestResults,
    }, dispatch);
}

export default connect(mapStateToProps, dispatchToProps)(Test);



// WEBPACK FOOTER //
// ./src/components/Test.js